import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MultiSelectComponent } from '@engie-group/fluid-design-system-angular';
import { AlertLevel, AlertMessage } from 'src/app/core/Dtos/alert.entity';
import { Assets } from 'src/app/core/Dtos/assets-enum';
import { ListItemData } from 'src/app/core/Dtos/list-item-data';
import { MorayWestInstructionDTO } from 'src/app/core/Dtos/moray-west/instructions-dto';
import { AlertsService } from 'src/app/core/services/alerts.service';
import { DateFormatHelperService } from 'src/app/core/services/date-format-helper.service';
import { GeneralDataService } from 'src/app/core/services/general-data.service';
import { MorayWestService } from 'src/app/core/services/moray-west.service';

@Component({
  selector: 'app-moray-west',
  templateUrl: './moray-west.component.html',
  styleUrl: './moray-west.component.scss',
  standalone: false
})
export class MorayWestComponent {
  public Instruction: MorayWestInstructionDTO = new MorayWestInstructionDTO();
  public BMUList: string[] = [];

  constructor(
    private _generalDataService: GeneralDataService,
    private _morayWestService: MorayWestService,
    private _router: Router,
    private _alertService: AlertsService,
    private _activatedRoute: ActivatedRoute,
    private _dateFormatHelper: DateFormatHelperService
  ) {
    this._generalDataService.GetBMUs(Assets.MorayWest).subscribe(
      resp => {
        this.BMUList = resp;
        let id = _activatedRoute.snapshot.paramMap.get("id");
        if (id !== null)
          this.GetInstruction(parseInt(id));
      }
    );
  }

  GetInstruction(id: number) {
    this._morayWestService.GetInstructionById(id).subscribe(
      resp => {
        resp.issuedFrom = null;
        this.Instruction = resp;
      }
    )
  }

  public SaveInstruction() {
    if (!this.ValidateInstruction())
      return;

    this._morayWestService.SaveInstruction(this.Instruction).subscribe(
      resp => this.Cancel()
    );
  }

  private ValidateInstruction(): boolean {
    let sErr: string[] = [];
    if ((this.Instruction.units ?? "") == "")
      sErr.push("Affected Unit/s");
    if ((this.Instruction.issuedFrom ?? "") == "")
      sErr.push("Issued From");

    if ((this.Instruction.fixed?.toString() ?? "") == "")
      sErr.push("Monthly Fixed Elements");

    if ((this.Instruction.units ?? "") != "MOWWL-4") {
      if ((this.Instruction.amazon_commissioning?.toString() ?? "") == "")
        sErr.push("Amazon 1 PPA - Commissioning Output");
      if ((this.Instruction.amazon_contracted?.toString() ?? "") == "")
        sErr.push("Amazon 1 PPA - Contracted Electrical Output");
      if ((this.Instruction.amazon_commercial?.toString() ?? "") == "")
        sErr.push("Amazon 1 PPA - Payment Element");

      if ((this.Instruction.google_commissioning?.toString() ?? "") == "")
        sErr.push("Google PPA - Commissioning Output");
      if ((this.Instruction.google_contracted?.toString() ?? "") == "")
        sErr.push("Google PPA - Contracted Electrical Output");
      if ((this.Instruction.google_commercial_min?.toString() ?? "") == "")
        sErr.push("Google PPA - Minimum Payment Element");
      if ((this.Instruction.google_commercial_max?.toString() ?? "") == "")
        sErr.push("Google PPA - Maximum Payment Element");

      if ((this.Instruction.engie_commissioning?.toString() ?? "") == "")
        sErr.push("Engie Nose 1 PPA - Commissioning Output");
      if ((this.Instruction.engie_contracted?.toString() ?? "") == "")
        sErr.push("Engie Nose 1 PPA - Contracted Electrical Output");
    }
    else {
      if ((this.Instruction.regoPrice?.toString() ?? "") == "")
        sErr.push("Rego Price");
      if ((this.Instruction.percentage?.toString() ?? "") == "")
        sErr.push("Percentage");
    }
    if (sErr.length != 0) {
      this._alertService.ShowAlert(new AlertMessage(AlertLevel.Error, `The following fields are missing: \n\r ${sErr.join(", ")} `));
      return false;
    }
    return true;
  }

  public BMU_Changed() {
    if (this.Instruction.units == "MOWWO-4") {
      this.Instruction.amazon_commercial = 0;
      this.Instruction.amazon_commissioning = 0;
      this.Instruction.amazon_contracted = 0;
      this.Instruction.google_commercial_min = 0;
      this.Instruction.google_commercial_max = 0;
      this.Instruction.google_commissioning = 0;
      this.Instruction.google_contracted = 0;
      this.Instruction.engie_commissioning = 0;
      this.Instruction.engie_contracted = 0;
    }
    else {
      this.Instruction.regoPrice = 0;
      this.Instruction.percentage = 0;
    }
  }

  public Cancel() {
    this._router.navigate(['mowwl']);
  }
}
